import React, { useContext, useEffect, useState } from 'react'
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  useMediaQuery,
  useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Loading from '../../Common/Loading'
import { TenantsContext } from '../../../context/tenants.context'
import { ITenant } from '../../../pages/AbmLocalPage/types'

const DialogDuplicar: React.FC<{
  open: boolean
  setOpen: (op: boolean) => void
  codLocal: string
  newTenant: ITenant
  setNewTenant: (tenant: ITenant) => void
  handleDuplicar: () => Promise<void>
  loading: boolean
}> = ({ codLocal, open, setOpen, newTenant, setNewTenant, handleDuplicar, loading }) => {
  const { tenant, fetchTenants, tenants } = useContext(TenantsContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    if (open && (!tenants || tenants.length === 0)) {
      fetchTenants()
    }
  }, [codLocal, open])

  const handleClose = () => {
    setOpen(false)
    setNewTenant(null)
  }

  if (open && (!tenant || tenants.length === 0)) return <Loading />

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={isMobile ? 'xs' : 'sm'}
        PaperProps={{
          style: {
            overflowX: 'hidden',
            ...(isMobile && { marginLeft: '-1rem' })
          }
        }}
      >
        <DialogTitle style={{ marginTop: '0.5rem' }}>Duplicar local en otra tenancy</DialogTitle>
        <DialogContent>
          <Autocomplete
            disabled={loading}
            options={tenants}
            getOptionLabel={(tenant: ITenant) => tenant.nombre || ''}
            onChange={(event, value) => setNewTenant(value || null)}
            renderInput={(params) => <TextField placeholder="Seleccionar" {...params} variant="outlined" />}
            value={newTenant}
            renderOption={(props, t) => (
              <MenuItem {...props} key={t.path} value={t.path}>
                {t.nombre}
              </MenuItem>
            )}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', mt: '1rem', gap: '1rem', justifyContent: 'space-between' }}>
            <Button disabled={loading} variant="contained" color="error" sx={{ width: '100%' }} onClick={handleClose}>
              Volver
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              color="success"
              sx={{ width: '100%' }}
              onClick={handleDuplicar}
            >
              Duplicar
            </Button>
          </Box>
        </DialogContent>
        <IconButton
          disabled={loading}
          edge="end"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '16px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </Dialog>
    </>
  )
}

export default DialogDuplicar
